import React from "react";
import "./ddd.css";

function DDDUI({ imageUrl, onBack, backButtonDisabled, children }) {
  const handleBackClick = (e) => {
    if (backButtonDisabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onBack?.();
  };
  return (
    <>
      <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL}><img src={imageUrl} alt="Header" className="logo-holder" /></a>
        <div className="back-holder">
        <button type="button" onClick={handleBackClick} className="back-default" disabled={backButtonDisabled}>Back</button>
        </div>
       
      </header>
      {children}
    </>
  );
}

export default DDDUI;